import React from 'react';
import SuccessIcon from '@mui/icons-material/CheckCircle';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import { useLocalization } from '@/localization';
import State from '@/store/state';
import { StyledNotificationDetails, StyledNotificationMessage, StyledNotificationRoot, StyledNotificationText, } from './notifications.style';
export const NotificationContent = ({ onClick, message, type, details, }) => {
    const { formatMessage: t } = useLocalization();
    const formattedMessage = typeof message === 'string' ? message : t({ key: message.key, values: message.values });
    return (<StyledNotificationRoot onClick={onClick} $type={type}>
      {State.Notification.Type.ERROR === type ? <WarningRoundedIcon /> : <SuccessIcon />}
      <StyledNotificationText>
        <StyledNotificationMessage>{formattedMessage}</StyledNotificationMessage>
        {details && <StyledNotificationDetails>{details}</StyledNotificationDetails>}
      </StyledNotificationText>
    </StyledNotificationRoot>);
};
export default NotificationContent;
